(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["spp-samples-button"] && !Shopify.designMode) return;
  try {
    const sampleRoots = new WeakSet();
  function initSampleButtons() {
    document.querySelectorAll('[id^="MainProduct-"]').forEach(root => {
      if (sampleRoots.has(root)) return;
      sampleRoots.add(root);
      let frame = 0;
      function position() {
        frame = 0;
        const source = root.querySelector('[data-spp-samples-source]');
        if (!source) return;
        let placed = 0;
        root.querySelectorAll('#infiniteoptions-container [role="group"]').forEach(field => {
          const name = field.getAttribute('aria-labelledby') || '';
          if (!/^(Strebenfarbe|Netzfarbe|Strut colou?r|Bar colou?r|Net colou?r)/i.test(name)) return;
          const heading = field.querySelector('.spb-label-tooltip');
          if (!heading) return;
          heading.classList.add('spp-samples-heading');
          if (!heading.querySelector('.spp-samples-cta')) {
            const cta = source.cloneNode(true);
            cta.removeAttribute('data-spp-samples-source');
            cta.removeAttribute('hidden');
            heading.append(cta);
          }
          placed++;
        });
        source.hidden = placed > 0;
      }
      function schedule() {
        if (!frame) frame = requestAnimationFrame(position);
      }
      const observer = new MutationObserver(schedule);
      observer.observe(root, { childList: true, subtree: true });
      root.addEventListener('shopify:section:unload', () => {
        observer.disconnect();
        cancelAnimationFrame(frame);
      }, { once: true });
      schedule();
    });
  }
  initSampleButtons();
  document.addEventListener('shopify:section:load', initSampleButtons);
  } catch(e) { console.error(e); }
})();

})();
